import { FC } from 'react';
import { AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  error?: unknown;
}

const ErrorScreen: FC<Props> = ({ error }) => {
  const { t } = useTranslation(["checkout"]);
  const message =
    (error as any)?.response?.data?.message ??
    t(
      "checkout:error-init-failed",
      "Unable to load the payment page. Please try again.",
    );

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-red-100">
        <AlertCircle className="size-8 text-red-600" />
      </div>
      <h1 className="text-xl font-bold mb-2">
        {t("checkout:error-title", "Something went wrong")}
      </h1>
      <p className="text-muted-foreground">{message}</p>
    </div>
  );
};

export default ErrorScreen;
